import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Profile } from "./pages/profile/Profile";

export const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Profile />} />
      </Routes>
    </BrowserRouter>
  );
};
